import React, { useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SidebarNav.css';

/**
 * 统一侧边导航组件
 * - 默认隐藏，hover 时展开
 * - 所有页面共用
 */
const SidebarNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef(null);

  // 导航配置
  const navItems = [
    { path: '/', icon: '📱', label: '发现', title: '发现互动空间' },
    { path: '/grid', icon: '🎬', label: '全部', title: '全部互动空间' },
  ];

  // 判断当前路径是否激活
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // 鼠标进入
  const handleMouseEnter = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setVisible(true);
  }, []);

  // 鼠标离开
  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
    }, 300);
  }, []);

  // 导航点击
  const handleNavClick = (path) => {
    navigate(path);
  };

  return (
    <>
      {/* 触发区域 - 左侧边缘 */}
      <div 
        className="sidebar-trigger"
        onMouseEnter={handleMouseEnter}
      />
      
      {/* 侧边导航栏 */}
      <nav 
        className={`sidebar-nav-unified ${visible ? 'visible' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Logo */}
        <div className="sidebar-logo" onClick={() => navigate('/')}>
          <span className="logo-icon">🤖</span>
        </div>
        
        {/* 导航菜单 */}
        <div className="sidebar-menu">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleNavClick(item.path)}
              title={item.title}
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default SidebarNav;
